import { createApi } from '@reduxjs/toolkit/query/react';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

import { CmsDimension, CmsDimensionsResponse } from './cmsDimensions.types';

const cmsDimensionsApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api/cms',
  }),
  reducerPath: 'cmsDimensions',
  tagTypes: ['CmsDimensions'],
  endpoints: (build) => ({
    getCmsDimensions: build.query<CmsDimension[], void>({
      query: () => ({
        url: '/dimensions',
        method: 'GET',
      }),
      transformResponse: (response: CmsDimensionsResponse) =>
        response.dimensions ?? [],
    }),
  }),
});

export default cmsDimensionsApi;
